import * as React from 'react';

import { Header } from 'bundles/enterprise-ui/components';

const WithBusinessHeader = ({ children, ...props }: $TSFixMe) => {
  return (
    <div className="styleguide" data-testid="xapi_business_header">
      <Header />
      {React.cloneElement(children as JSX.Element, props)}
    </div>
  );
};

export default WithBusinessHeader;
